export const URL_ORDER_LIST = "/v1/orderonline/order/site/list"
export const URL_ORDER_DETAIL = "/v1/orderonline/order/site/get?"
export const URL_UPDATE_STATUS = "/v1/orderonline/order/form/update-status"
export const URL_ITEM_DETAIL = "/v1/orderonline/item/site/get?"
export const URL_ADD_ITEM = "/v1/orderonline/order/order-items/add"
export const URL_UPDATE_ITEM = "/v1/orderonline/order/order-items/update"
export const URL_CANCEL_ITEM = "/v1/orderonline/order/order-items/cancel"
export const URL_GET_ITEM = "/v1/orderonline/item/site/get?"
export const URL_CHECK_UPDATE = "/v1/orderonline/order/site/check-update"